import React from "react";
import Helmet from "react-helmet";

import HomeLayout from "../components/HomeLayout";

const Page = () => (
	<>
		<Helmet title="Messenger" />
		<HomeLayout>
			<h1>Messenger</h1>
		</HomeLayout>
	</>
);

export default Page;
